import { Controller } from "@hotwired/stimulus"
import { TempFormHelper } from "~/helpers/temp_form_helper"

// This controller is used to use selected or currently filtered leads to create a new campaign.
export default class extends Controller {
  static get values() {
    return {
      filters: { type: Object, default: {} },
      filtersType: String,
      outreachEnabled: Boolean,
      selectedLeadIds: { type: Array, default: [] },
      source: String
    }
  }

  // This action submits a temporary form to create a new campaign with the selected or filtered leads if
  // the preconditions are met.
  submit() {
    if (!this.outreachEnabledValue) {
      App.displayFlash("danger", i18n.t("js.back.lead_actions.connect_google_account_html"))
      return
    }

    if (this.selectedLeadIdsValue.length === 0 && Object.keys(this.filtersValue).length === 0) {
      if (this.filtersTypeValue === "engagement") {
        App.displayFlash("danger", i18n.t("js.back.lead_actions.filter_or_select_recipients_to_new_campaign"))
      } else {
        App.displayFlash("danger", i18n.t("js.back.lead_actions.filter_or_select_leads_to_new_campaign"))
      }

      return
    }

    if (this.hasFiltersValue && this.filtersValue.email === "~") {
      App.displayFlash("danger", i18n.t("js.back.lead_actions.email_blank_filter_is_not_allowed_to_new_campaign"))
      return
    }

    App.displayFlash("success", i18n.t("js.back.lead_actions.creating_campaign"), null, 300000)

    TempFormHelper.create("/campaigns", "post", (form) => {
      this.selectedLeadIdsValue.forEach(leadId => { TempFormHelper.addHiddenInput(form, "lead_ids[]", leadId) })
      TempFormHelper.addHiddenInput(form, "filters_type", this.filtersTypeValue)
      TempFormHelper.addHiddenInput(form, "action_source", this.sourceValue)
    }).submit()
  }

  // This action is used to update the selected leads value.
  // We trigger this using the check-all controller.
  updateSelection(event) {
    if (event.detail.allSelected) {
      this.selectedLeadIdsValue = []
    } else if (event.detail.dataSets) {
      this.selectedLeadIdsValue = event.detail.dataSets.map(dataSet => dataSet.leadId || dataSet.recordId).filter(Boolean)
    } else {
      this.selectedLeadIdsValue = []
    }
  }
}
